import { UserAvatar } from '@v2/components/display/UserAvatar/UserAvatar';
import { cn } from '@v2/lib/utils';
import React from 'react';

export type UserInfoProps = {
  name: string;
  profile_photo_url?: string;
  title?: string;
  badge?: React.ReactNode;
  classNames?: string;
};

export const UserInfo = ({
  name,
  profile_photo_url,
  title,
  badge,
  classNames
}: UserInfoProps) => {
  return (
    <div className={cn('flex w-full items-center justify-start', classNames)}>
      <div className="relative flex-shrink-0">
        {badge}
        <UserAvatar
          user={{
            name,
            profile_photo_url
          }}
          size="md"
        />
      </div>
      <div className="ml-2 flex flex-col justify-start align-center gap-1 overflow-hidden flex-grow">
        <div className="text-sm truncate">
          <span className="truncate">{name}</span>
        </div>
        {!!title && (
          <div className="text-gray-500 text-xs truncate">
            <span className="truncate">{title}</span>
          </div>
        )}
      </div>
    </div>
  );
};
